import { useEffect, useState } from "react";
import styled from "styled-components/macro";
import useFetchCountSeverities from "services/hooks/issues/useFetchCountSeverities";
import { useNavigate } from "react-router-dom";

const StyledHighestLevel = styled.div`
  position: relative;
  display: inline-block;
`;

const SquareContainer = styled.div`
  position: relative;
  width: 3.5rem;
  height: 3.5rem;
  border: 0.2vw solid;
  &.critical {
    border-color: ${({ theme }) => theme.red};
  }
  &.high {
    border-color: ${({ theme }) => theme.orange};
  }
  &.medium {
    border-color: ${({ theme }) => theme.yellow};
  }
  &.low {
    border-color: ${({ theme }) => theme.green};
  }
  &.info {
    border-color: ${({ theme }) => theme.blue};
  }
  transform: rotate(45deg);
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;

const Score = styled.span`
  position: relative;
  color: white;
  font-weight: bold;
  font-size: 2.5rem;
  transform: rotate(-45deg);
`;

const SeverityLevel = ({ className, entityId, highestLevel: propHighestLevel }) => {
  const [highestLevel, setHighestLevel] = useState(propHighestLevel || null);
  const { isSuccess, data } = useFetchCountSeverities({
    entityId,
    status: ["pending", "in progress"],
  });

  const navigate = useNavigate();

  const handleClick = (highestSeverityValue, entityId) => {
    if (entityId) {
      navigate(
        `/issues?entityId=${entityId}&tab=pending&severity=${highestSeverityValue}`
      );
    } 
  };

  useEffect(() => {
    if (propHighestLevel) {
      setHighestLevel(propHighestLevel);
    } else if (isSuccess) {
      const highestSeverity = data.find((d) => d.highest);
      if (highestSeverity) {
        setHighestLevel({
          value: highestSeverity.value,
          label: highestSeverity.label,
          score: highestSeverity.score,
        });
      } else {
        setHighestLevel({
          value: "info",
          label: "No Severity",
          score: 5,
        });
      }
    }
  }, [isSuccess, data, propHighestLevel]);

  return (
    <div
      className={className}
      type="button"
      onClick={highestLevel ? () => handleClick(highestLevel.value, entityId) : undefined}
      style={{ cursor: highestLevel && entityId ? "pointer" : "default" }}
    >
      <StyledHighestLevel>
        <SquareContainer className={highestLevel?.value}>
          <Score>{highestLevel?.score || "-"}</Score>
        </SquareContainer>
      </StyledHighestLevel>
    </div>
  );
};

export default SeverityLevel;